import { useMemo, useState } from "react";

import { MessageThreadTitle } from "src/core/constants/folder";
import { useFolder } from "src/core/contexts/FolderContext";

export const useFolderMessageThread = () => {
  const { folderFile } = useFolder();

  const [messageThreadOpen, setMessageThreadOpen] = useState<boolean>(false);

  const displayMessageThread = useMemo<boolean>(() => {
    return (
      folderFile?.folderFile?.messageThreads?.find(
        (mt) => mt.title === MessageThreadTitle.COMMENTS
      ) !== undefined
    );
  }, [folderFile.folderFile?.messageThreads]);

  return {
    displayMessageThread,
    messageThreadOpen,
    setMessageThreadOpen,
  };
};
